import React from "react"
import {Badge} from "../Badge/Badge"
import classNames from "classnames"
import {
	formatNameMismatchTypesForDisplay,
	normalizeNameMatchKey,
} from "../AssignmentPageItemNameMismatch/nameMismatchPartyRoles"

interface UnscoredRowProps {
	name: string
	nameRoleMap?: Record<string, string[]>
	showTypeColumn: boolean
	disabled?: boolean
}

export function UnscoredRow({name, nameRoleMap, showTypeColumn, disabled}: UnscoredRowProps) {
	return (
		<tr>
			<td className={classNames("name-cell", disabled && "disabled")}>
				<Badge className="badge-text" text={name} />
			</td>
			{showTypeColumn && (
				<td className={classNames(disabled && "disabled")}>
					{formatNameMismatchTypesForDisplay(nameRoleMap?.[normalizeNameMatchKey(name)])}
				</td>
			)}
		</tr>
	)
}
